exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../styles/mixins.css"), undefined);

// module
exports.push([module.id, "._2XHDFj5K3YP_ecVc0V9WKA{margin-top:25px;margin-bottom:25px;border-top-width:1px;border-top-style:solid;text-align:center;padding:0;border-bottom:none;border-left:none;border-right:none};._31qBHBYgk11L6wWAPT9MjP{padding-right:10px;padding-left:10px;font-size:10px;line-height:1px;text-align:center;text-transform:uppercase;letter-spacing:1px}", ""]);

// exports
exports.locals = {
	"divider": "_2XHDFj5K3YP_ecVc0V9WKA " + require("-!../../../node_modules/css-loader/index.js?modules&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../styles/mixins.css").locals["borderColor"] + "",
	"content": "_31qBHBYgk11L6wWAPT9MjP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/divider/divider.css
// module id = 282
// module chunks = 0 1 2